import { MutationTree } from 'vuex';
import {
  State,
  ExtTagFormData,
  ErrorInForm,
} from '@/store/modules/alertV2/extTagGrouping/extTagGrouping.store';
import { extTagFormDefaultData } from '@/components/AlertsV2/external-tag-grouping/extTags.types';
import _ from 'lodash';
import { ExtTagTableInfo } from '@/store/modules/alertV2/extTagGrouping/interfaces';
import { initialState } from '@/store/modules/alertV2/extTagGrouping/extTagGrouping.store';

interface ExtTagFieldInfoType {
  field: string;
  value: any;
}

const mutations: MutationTree<State> = {
  setIsExtTagFormOpened(state: State, data: boolean) {
    state.isExtTagFormOpened = data;
  },
  setIsExtTagFormEdit(state: State, data: boolean) {
    state.isExtTagFormEdit = data;
  },
  setExtTagTableInfo(state: State, data: ExtTagTableInfo) {
    state.extTagTableInfo = data;
  },
  setExtTagFormUtils(state: State, data: ExtTagFieldInfoType) {
    state.formUtils[data.field] = data.value;
  },
  setWebhookMapping(state: State, data: Object) {
    if (data['webhook']) {
      state.webhookMapping = { ...state.webhookMapping, ...data };
    } else {
      const webhook = state.webhookMapping.webhook;
      state.webhookMapping = { ...state.webhookMapping, ...data };
      state.webhookMapping.webhook = webhook;
    }
  },
  setExtTagFormData(state: State, data: ExtTagFormData) {
    state.extTagFormData = data;
    state.webhookMapping.webhook = state.extTagFormData.webhook;
  },
  setExtTagFields(state: State, data: Object) {
    state.extTagFormData.extTagFields = {
      ...state.extTagFormData.extTagFields,
      ...data,
    };
  },
  setExtTagConditions(
    state: State,
    { fieldName, value }: { fieldName: string; value: string },
  ) {
    state.extTagFormData.extTagConditions = {
      ...state.extTagFormData.extTagConditions,
      [fieldName]: value,
    };
  },
  setTagInfo(state: State, data: Object) {
    state.extTagFormData.tagInfo = {
      ...state.extTagFormData.tagInfo,
      ...data,
    };
  },
  resetExtTagPageField(state: State) {
    state.extTagFormData = _.cloneDeep(extTagFormDefaultData);
    state.isErrorInForm.tagInfo = true;
    state.isErrorInForm.webhookInfo = true;
  },
  setIsErrorInForm(state: State, data: Object) {
    state.isErrorInForm = {
      ...state.isErrorInForm,
      ...data,
    };
  },
  setIsClearEnabled(state: State, data: boolean) {
    state.isClearEnabled = data;
  },
  setNewTagGrpAllowed(state: State, data: boolean) {
    state.newTagGrpAllowed = data;
  },
  clearExtTagPageField(state: State) {
    state.extTagFormData.extTagConditions = {};
    state.extTagFormData.extTagFields = {};
    state.isErrorInForm.webhookInfo = true;
  },
  setDefaultValues(state: State) {
    Object.assign(state, { ...initialState });
  },
};

export default mutations;
